var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Icon } from './Icon';
export var HandleIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("rect", { width: "20", height: "4", x: "2", y: "10", fill: "#B4B8B8", fillRule: "evenodd", rx: "2" }))); };
//# sourceMappingURL=HandleIcon.js.map